import { Element } from "./getWord";

export function getGeometry(element: Element) {
    return ({
        polygon: element.polygon,
        boundingBox: element.bbox && { x: element.bbox.x, y: element.bbox.y, w: element.bbox.width, h: element.bbox.height }
    })
}